
import { defineComponent, ref, watch } from 'vue';
import { message } from 'ant-design-vue';
import { noEmptyProp, not } from '@/utils/illuminate';
import { createApiUrl } from '@/utils/utils';
import type { TableColumn } from '@/components/Table';
import { request } from '@/utils/request';

export default defineComponent({
  name: 'ChargeList',
  props: {
    type: {
      type: Number,
      default: 0,
    },
  },
  // emits: ['update:visible', 'close'],
  setup(props, { emit }) {
    const activeKey = ref('1');
    const visible = ref(false);
    const filterParams = ref({});
    const tableRef = ref<any>(null);

    const tableColumns: TableColumn[] = [
      { title: '订单编号', dataIndex: 'orderNo', width: '150px', align: 'center' },
      { title: '部门', dataIndex: 'accountMainDeptName', width: '150px', align: 'center' },
      { title: '员工姓名', dataIndex: 'userName', width: '150px', align: 'center' },
      { title: '手机号码', dataIndex: 'phone', width: '150px', align: 'center' },
      { title: '车牌', dataIndex: 'plateNumber', width: '150px', align: 'center' },
      { title: '订单总金额', dataIndex: 'totalOrderAmount', width: '120px', align: 'center' },
      { title: '服务费金额', dataIndex: 'serviceAmount', width: '120px', align: 'center' },
      { title: '占桩费金额', dataIndex: 'occupyAmount', width: '120px', align: 'center' },
      { title: '最终实付金额', dataIndex: 'totalRealAmount', align: 'center', width: '120px' },
      { title: '站点名称', dataIndex: 'stationName', width: '150px', align: 'center' },
      { title: '度数', dataIndex: 'chargingDegree', width: '120px', align: 'center' },
      { title: '支付方式', dataIndex: 'payTypeDesc', width: '120px', align: 'center' },
      { title: '支付时间', dataIndex: 'payTime', width: '180px', align: 'center' },
      { title: '下单时间', dataIndex: 'createDate', width: '180px', align: 'center', fixed: 'right' },
    ];

    const tableColumns1: TableColumn[] = [
      { title: '订单编号', dataIndex: 'orderNo', width: '150px', align: 'center' },
      { title: '部门', dataIndex: 'accountMainDeptName', width: '150px', align: 'center' },
      { title: '员工姓名', dataIndex: 'userName', width: '150px', align: 'center' },
      { title: '手机号码', dataIndex: 'phone', width: '150px', align: 'center' },
      { title: '车牌', dataIndex: 'plateNumber', width: '150px', align: 'center' },
      { title: '订单总金额', dataIndex: 'totalOrderAmount', width: '120px', align: 'center' },
      { title: '企业实付金额', dataIndex: 'totalRealAmount', width: '120px', align: 'center' },
      { title: '站点名称', dataIndex: 'stationName', width: '150px', align: 'center' },
      { title: '支付方式', dataIndex: 'payTypeDesc', width: '120px', align: 'center' },
      { title: '支付时间', dataIndex: 'payTime', width: '180px', align: 'center' },
      { title: '下单时间', dataIndex: 'createDate', width: '180px', align: 'center', fixed: 'right' },
    ];

    const loadTableData = async (parameter: any) => {
      console.log('filterParams', filterParams.value);
      // if (!props.filterParams.dateRange.length && !props.filterParams.isAll) return { list: [] };

      // const params: any = {
      //   ...noEmptyProp(not(props.filterParams, ['dateRange', 'enterprise'])),
      //   enterpriseId: props.filterParams.enterprise.enterpriseId,
      //   departmentId: props.filterParams.departmentId,
      // };

      // if (props.filterParams.dateRange.length) {
      //   params.startTime = props.filterParams.dateRange[0].valueOf();
      //   params.endTime = props.filterParams.dateRange[1].valueOf();
      // }

      let res: any;
      try {
        let url = '';
        if (activeKey.value === '1') {
          url = props.type === 0 ? '/newlinkSass/invoice/find-center-invoice-ele-order-list' : '/newlinkSass/invoice/find-invoice-ele-orders';
        } else {
          url = props.type === 0 ? '/newlinkSass/invoice/find-center-invoice-overtime-order-list' : '/newlinkSass/invoice/find-invoice-overtime-orders';
        }
        // const url = activeKey.value === '1' ? '/newlinkSass/invoice/find-center-invoice-ele-order-list' : '/newlinkSass/invoice/find-center-invoice-overtime-order-list'
        console.log('url', url);
        res = await request.post(createApiUrl(url), { ...parameter, ...filterParams.value });
      } catch (e: Error & any) {
        message.error(e.message);
        throw e;
      }
      return res.data || {};
    };
    const show = (params: any) => {
      console.log('params', params);
      activeKey.value = '1';
      visible.value = true;
      filterParams.value = params;
      // loadTableData(params)
    };

    const onClose = () => {
      activeKey.value = '';
      visible.value = false;
    };

    return {
      activeKey,
      tableRef,
      tableColumns,
      tableColumns1,
      loadTableData,
      onClose,
      visible,
      show,
    };
  },
});
